import React from 'react';
import RandomString from 'randomstring';
import { Card, Position, Toaster } from "@blueprintjs/core";
import { storage } from '../../../fire';

import Session from '../../../services/Session';
import Auth from '../../../services/Auth';

import { toast_deleteError, toast_deleteSuccess, toast_uploadError, toast_uploadInProgress, toast_uploadSuccess, toast_warningError } from "./MC/Toast";
import DialogAddChannel from './MC/DialogAddChannel';
import DialogAddFixedChannel from './MC/DialogAddFixedChannel';
import CreatePanelProtocolMCTable from './MC/TableCriterias';

class CreatePanelProtocolMC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogIsOpen: false,
            dialogIsOpenFixed: false,
            criteria: {
                name: null,
                file: null,
                fileBlob: null,
                downloadURL: null
            },
            submiting: false,
            isDeletingCriteria: false,
            newCriterias: [],
            fixedChannel: false
        }
    }

    handleOpenDialog = () => this.setState({ dialogIsOpen: true });
    handleCloseDialog = () => this.setState({ dialogIsOpen: false });

    handleOpenDialogFixed = () => this.setState({ dialogIsOpenFixed: true });
    handleCloseDialogFixed = () => this.setState({ dialogIsOpenFixed: false });

    handleChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const currentCriteriaState = this.state.criteria;

        this.setState({ criteria: { ...currentCriteriaState, [name]: value } });
    }

    handleChangeFileInput = (e) => {
        let files = []
        for (let i = 0; i < e.target.files.length; i++) {

            let newFile = e.target.files[i]
            let file = RandomString.generate(16);
            let name = newFile.name;
            let blob = newFile

            let type

            if (newFile.type.includes('image')) {
                type = 'IMAGE'
            } else {
                alert('Unauthorized file type')
            }

            files.push({ name: name, file: file, fileBlob: blob, type: type, downloadURL: null, isFixed: false })
            if (i === e.target.files.length - 1) {
                this.setState({ newCriterias: this.state.newCriterias.concat(files) });
            }
        }
    }

    handleChangeFileInputFixed = (e) => {
        if (e.target.files.length > 1) {
            alert('You can only add one fixed channel')
        } else {
            let newFile = e.target.files[0]
            let file = RandomString.generate(16);
            let name = newFile.name;
            let blob = newFile

            let type

            if (newFile.type.includes('image')) {
                type = 'IMAGE'
            } else {
                alert('Unauthorized file type')
            }
            this.setState({ newCriterias: [{ name: name, file: file, fileBlob: blob, type: type, downloadURL: null, isFixed: true }], fixedChannel: true });
        }


    }


    handleAddCriteria = () => {
        this.setState({ submiting: true });
        this.state.newCriterias.forEach((newCriteria) => {
            let { onChangeCriterias, criterias, sessionId } = this.props;
            let uploadToastKey = this.toaster.show(toast_uploadInProgress(0));
            this.handleCloseDialogFixed()
            const storageRef = Session.addChannelCriteriaImage({
                sessionId,
                newCriteria,
                onProgress: (snapshot) => {
                    /**
                     * Upload is in progress
                     * --
                     * Calculate purcentage of uploading
                     * Update the upload toast with the new purcentage
                     */
                    let progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);

                    this.toaster.show(toast_uploadInProgress(progress), uploadToastKey);
                },
                onError: (e) => {
                    /**
                     * Upload has errored
                     * --
                     * Set the new state (no more submiting and criteria obj is reseted)
                     * Close the 'Ajouter un critère' dialog
                     * Dismiss the upload toast
                     * Show an error toast
                     */
                    this.setState({ submiting: false, criterias: [] });
                    this.handleCloseDialog();
                    this.toaster.dismiss(uploadToastKey);
                    this.toaster.show(toast_uploadError());
                    console.error('An error has been occured when uploading\n', e.message);
                },
                onComplete: () => {
                    /**
                     * Upload is complete
                     * --
                     * Give an id to the criteria (usefull for criteria removing)
                     * Get the download URL of the uploaded file (async)
                     * Push the criteria to the list of criterias (omit the fileBlob attribute)
                     * Call prop handler 'onChangeCriterias' to update the list of criteria of the parent component
                     * Set the new state (update list of criteria, no more submiting and criteria obj is reseted)
                     * Dismiss the upload toast
                     * Show a success toast
                     */
                    storageRef
                        .getDownloadURL()
                        .then((url) => newCriteria.downloadURL = url)
                        .then(() => {
                            criterias.push({ id: RandomString.generate(16), name: newCriteria.name, file: newCriteria.file, downloadURL: newCriteria.downloadURL, isFixed: newCriteria.isFixed });
                            onChangeCriterias(criterias);
                            this.setState({ submiting: false, newCriterias: [], fixedChannel: false });
                            this.handleCloseDialog();
                            this.toaster.dismiss(uploadToastKey);
                            this.toaster.show(toast_uploadSuccess());
                        })
                }
            })
        })
    }


    handleDeleteCriteria = (id) => {
        let { criterias } = this.props;
        const { onChangeCriterias, sessionId } = this.props;
        const storageRef = storage.ref(`${this.storageBaseRef}/${sessionId}/${criterias.find((c) => c.id === id).file}`);
        const deleteCriteria = () => {
            // Delete the element that has the given id using Array.filter
            criterias = criterias.filter((c) => c.id !== id);
            onChangeCriterias(criterias);
        }

        this.setState({ isDeletingCriteria: true });
        storageRef.delete()
            .then(() => {
                this.toaster.show(toast_deleteSuccess())
                deleteCriteria();
                this.setState({ isDeletingCriteria: false });
            })
            .catch((e) => {
                const { code } = e;

                this.setState({ isDeletingCriteria: false });
                switch (code) {
                    case 'storage/unknown':
                        this.toaster.show(toast_deleteError("An unknown error has occurred..."));
                        break;
                    case 'storage/object-not-found':
                        this.toaster.show(toast_warningError("The image of the criterion was not found, we have still deleted the criterion.", 10000))
                        deleteCriteria();
                        break;
                    case 'storage/quota-exceeded':
                        this.toaster.show(toast_deleteError("Allocated storage space is full."))
                        break;
                    case 'storage/unauthenticated':
                        this.toaster.show(toast_deleteError("Thank you for authenticating !"))
                        break;
                    default:
                        this.toaster.show(toast_deleteError(e.message));
                        break;
                }
            })
    }


    render() {
        const { criterias, instances = [], onChangeCriterias, onChangeCriteriaName, handleChangeAttribute, handleChangeAttributeUnitValue, attributes, handleDeleteAttribute } = this.props;
        const { criteria, newCriterias, dialogIsOpen, isDeletingCriteria, dialogIsOpenFixed, fixedChannel } = this.state;

        return (
            <Card>
                <Toaster
                    position={Position.TOP_RIGHT}
                    autoFocus={false}
                    ref={(toaster) => this.toaster = toaster} />
                <DialogAddFixedChannel
                    criteria={criteria}
                    newCriterias={newCriterias}
                    dialogIsOpen={dialogIsOpenFixed}
                    onCloseDialog={this.handleCloseDialogFixed}

                    onChangeInput={this.handleChangeInput}
                    onAddCriteria={this.handleAddCriteria}
                    onChangeInputFile={this.handleChangeFileInputFixed}
                />

                <DialogAddChannel
                    criteria={criteria}
                    newCriterias={newCriterias}
                    dialogIsOpen={dialogIsOpen}
                    onCloseDialog={this.handleCloseDialog}

                    onChangeInput={this.handleChangeInput}
                    onAddCriteria={this.handleAddCriteria}
                    onChangeInputFile={this.handleChangeFileInput}
                />
                <CreatePanelProtocolMCTable
                    instances={instances}
                    criterias={criterias}
                    onDeleteCriteria={this.handleDeleteCriteria}
                    onOpenDialog={this.handleOpenDialog}
                    onOpenDialogFixed={this.handleOpenDialogFixed}
                    fixedChannel={fixedChannel}
                    isDeletingCriteria={isDeletingCriteria}
                    onChangeCriterias={onChangeCriterias}
                    onChangeCriteriaName={onChangeCriteriaName}
                    handleChangeAttribute={handleChangeAttribute}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleDeleteAttribute={handleDeleteAttribute}
                    attributes={attributes}
                />
            </Card>
        )
    }

    componentDidMount() {
        this.storageBaseRef = `channelCriterias/${Auth.getUserId()}`;
    }
}



export default CreatePanelProtocolMC;